var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("点击了"+_vm._s(_vm.count)+"次")]),_c('button',{on:{"click":_vm.Add}},[_vm._v("加")]),_c('button',{on:{"click":_vm.Reduce}},[_vm._v("减")]),_vm._l((_vm.todos),function(todo){return _c('div',{key:todo.id},[_vm._v(" "+_vm._s(todo.name)+" ")])}),_c('img',{attrs:{"src":_vm.url}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }